// https://app-designer.itcs.hp.com/builder/template-management/form/edit/189
// SIEBEL Partners
import { checkIsAmerica } from 'legacy/lut/classes/helpers/PartnerHelper'
import { DataModel } from 'legacy/lut/classes/models/DataModel'

import { IForm } from 'core-components/classes/models/IForm'

export const modifiedFieldsExt = [
  'AddressLine1',
  'AddressLine2',
  'AddressLine3',
  'City',
  'CommunicationName',
  'CompanyLegalName',
  'Country',
  'Email',
  'MainPhone',
  'MainPhoneCountryCode',
  'State',
  'TaxID',
  'URL',
  'ZIPCode',
  'Hierarchy',
  'TopPartnerID',
  'MembershipDate',
]

export const FieldsPartnerExt = [
  ...modifiedFieldsExt,
  'WorkflowStatus',
  'Modified',
  'ModifiedBy',
  'ProfileTeamComment',
]

export const FieldsLegalExt = [
  'CompanyLegalName',
  'LegalAddr1',
  'LegalAddr2',
  'LegalAddr3',
  'LegalPostalCode',
  'LegalCity',
  'LegalCountry',
  'LegalState',
  'LegalWorkflowStatus',
  'LegalModifiedValues',
  'LegalApproverComment',
]

export interface IFormPartners extends IForm {
  EntryID?: number
  Accreditations?: string
  City?: string
  Country?: string
  Email?: string
  HierarchyType?: string
  Region?: string
  AddressLine1?: string
  AddressLine2?: string
  AddressLine3?: string
  BankAccount?: string
  BankAccountName?: string
  BankName?: string
  CommunicationName?: string
  CompanyLegalName?: string
  CompanyDomains?: string
  LastUpdatedDate?: string
  LocationID?: string
  MainPhone?: string
  MainPhoneCountryCode?: string
  Organization?: string
  ParentLocationID?: string
  ParentPartnerID?: string
  PartnerID?: string
  ProfileUpdateDate?: string
  State?: string
  TaxID?: string
  IsAP?: number
  TopPartnerID?: string
  URL?: string
  ZIPCode?: string
  WorkflowStatus?: string | null
  PartnerFlagStatus?: string | null
  PartnerFlagModified?: string | null
  ParentTeamComment?: string
  Modified?: string
  ModifiedBy?: string
  LinkedInLink?: string
  FacebookLink?: string
  TwitterLink?: string
  WhatsAppLink?: string
  PartnersExtEntryId?: number
  ModifiedValues?: string
  Hierarchy?: string
  HPD_Partner_GUID?: string
  AltVendorPc?: string
  AltVendorPrint?: string
  Stocking?: string
  eCommerce?: string
  TagIdList?: string
  eCommerceDetails?: string
  MembershipDate?: string
  Created?: string
  CreatedBy?: string
  PartnerSince?: string
  ResponseTimeUnits?: string
  ResponseTimeNumber?: number
  DormantDDQNotified?: number
  Hours?: string
  Image?: string
  Gallery?: string
  Description?: string
  LoyaltyIndex?: number
  Link?: string
  ServiceCoverage?: number
  PostalCodes?: string
  Lat?: string
  Lng?: string
  NeedUpdateInMetalocator?: number
  MainContact?: string
  ZipCodes?: string
  ZipCodeCovered?: number
  BackupContacts?: string
  CoverageNumber?: string
  CoverageUnit?: string
  PartnerCommunication?: string | null
  PartnerAgrees?: number | null
  Completement?: number
  EntryIdAdd?: number
  ModifiedAdd?: string
  ModifiedByAdd?: string
  Market?: string
  StoreNumber?: string
  Source?: string
}

export interface IFormPartnersList extends IForm {
  PartnerID: string
  HierarchyType: string
}

export const CreateExtByModel = (data: DataModel, withLegal?: boolean): IForm => {
  let Country = data.get('CountryExt') || data.get('Country') || ''
  if (!Country && checkIsAmerica(data)) {
    Country = data.get('LegalCountryExt') || data.get('LegalCountry') || ''
  }
  const form_data_table_406: IForm = {}

  const onboardingRequestId = data.get('OnboardingRequestId')
  if (onboardingRequestId) {
    form_data_table_406.OnboardingRequestId = onboardingRequestId
  }

  form_data_table_406.PartnerID = data.get('PartnerID') || ''
  form_data_table_406.EntryId = data.get('EntryIdExt') || data.get('EntryId') || ''
  form_data_table_406.Modified = data.get('Modified') || ''
  form_data_table_406.ModifiedBy = data.get('ModifiedBy') || ''
  form_data_table_406.AddressLine1 = data.get('AddressLine1Ext') || data.get('AddressLine1') || ''
  form_data_table_406.AddressLine2 = data.get('AddressLine2Ext') || data.get('AddressLine2') || ''
  form_data_table_406.AddressLine3 = data.get('AddressLine3Ext') || data.get('AddressLine3') || ''
  form_data_table_406.City = data.get('CityExt') || data.get('City') || ''
  form_data_table_406.CommunicationName =
    data.get('CommunicationNameExt') || data.get('CommunicationName') || ''
  form_data_table_406.Country = Country
  form_data_table_406.Email = data.get('EmailExt') || data.get('Email') || ''
  form_data_table_406.LocationID = data.get('LocationIDExt') || data.get('LocationID') || ''
  form_data_table_406.State = data.get('StateExt') || data.get('State') || ''
  form_data_table_406.TaxID = data.get('TaxIDExt') || data.get('TaxID') || ''
  form_data_table_406.URL = data.get('URLExt') || data.get('URL') || ''
  form_data_table_406.ZIPCode = data.get('ZIPCodeExt') || data.get('ZIPCode') || ''
  form_data_table_406.MainPhone = data.get('MainPhoneExt') || data.get('MainPhone') || ''
  form_data_table_406.MainPhoneCountryCode = (data.get('MainPhoneCountryCode') || '').replace(
    /[^0-9]+/gi,
    ''
  )
  form_data_table_406.ModifiedValues = data.get('ModifiedValues') || ''
  form_data_table_406.ProfileTeamComment = data.get('ProfileTeamComment') || ''
  form_data_table_406.ProfileApproverComment = data.get('ProfileApproverComment') || ''
  form_data_table_406.WorkflowStatus = data.get('WorkflowStatus') || ''
  form_data_table_406.TopPartnerID = data.get('TopPartnerIDExt') || data.get('TopPartnerID') || ''
  form_data_table_406.Hierarchy = data.get('Hierarchy') || ''
  form_data_table_406.Market = data.get('Market') || ''
  form_data_table_406.Source = data.get('Source') || ''
  form_data_table_406.SourceRequestor = data.get('SourceRequestor') || ''
  form_data_table_406.StoreNumber = data.get('StoreNumberExt') || data.get('StoreNumber') || ''
  form_data_table_406.Status = data.get('StatusExt') || data.get('Status') || ''

  if (withLegal) {
    form_data_table_406.CompanyLegalName =
      data.get('CompanyLegalNameExt') || data.get('CompanyLegalName') || ''
    form_data_table_406.CompanyEnglishName = data.get('CompanyEnglishName') || ''
    form_data_table_406.LegalAddr1 = data.get('LegalAddr1Ext') || data.get('LegalAddr1') || ''
    form_data_table_406.CompanyLegalNameNonLatin = data.get('CompanyLegalNameNonLatin') || ''
    form_data_table_406.LegalAddr2 = data.get('LegalAddr2Ext') || data.get('LegalAddr2') || ''
    form_data_table_406.LegalAddr3 = data.get('LegalAddr3Ext') || data.get('LegalAddr3') || ''
    form_data_table_406.LegalCity = data.get('LegalCityExt') || data.get('LegalCity') || ''
    form_data_table_406.LegalCountry = data.get('LegalCountryExt') || data.get('LegalCountry') || ''
    form_data_table_406.LegalState = data.get('LegalStateExt') || data.get('LegalState') || ''
    form_data_table_406.LegalPostalCode =
      data.get('LegalPostalCodeExt') || data.get('LegalPostalCode') || ''
  }
  return form_data_table_406
}

export const CreateAdditionalByModel = (data: DataModel): IForm => {
  const form_data_table_458: IForm = {}

  form_data_table_458.EntryId = data.get('EntryIdAdd') || ''
  form_data_table_458.FacebookLink = data.get('FacebookLink') || ''
  form_data_table_458.LinkedInLink = data.get('LinkedInLink') || ''
  form_data_table_458.TwitterLink = data.get('TwitterLink') || ''
  form_data_table_458.WhatsAppLink = data.get('WhatsAppLink') || ''
  form_data_table_458.CompanyDomains = data.get('CompanyDomains') || ''
  form_data_table_458.PartnerID = data.get('PartnerID') || ''
  form_data_table_458.AltVendorPc = data.get('AltVendorPc') || ''
  form_data_table_458.AltVendorPrint = data.get('AltVendorPrint') || ''
  form_data_table_458.Stocking = data.get('Stocking') || ''
  form_data_table_458.eCommerce = data.get('eCommerce') || ''
  form_data_table_458.eCommerceDetails = data.get('eCommerceDetails') || ''
  form_data_table_458.TagIdList = data.get('TagIdList') || ''
  form_data_table_458.PartnerCommunication = data.get('PartnerCommunication') || ''
  form_data_table_458.PartnerAgrees = data.get('PartnerAgrees') || 0
  form_data_table_458.PartnerSince = data.get('PartnerSince') || ''
  form_data_table_458.ResponseTimeUnits = data.get('ResponseTimeUnits') || ''
  form_data_table_458.ResponseTimeNumber = data.get('ResponseTimeNumber') || ''
  form_data_table_458.Hours = data.get('Hours') || ''
  form_data_table_458.Image = data.get('Image') || ''
  form_data_table_458.Gallery = data.get('Gallery') || ''
  form_data_table_458.Description = data.get('Description') || ''
  form_data_table_458.LoyaltyIndex = data.get('LoyaltyIndex') || ''
  form_data_table_458.Link = data.get('Link') || ''
  form_data_table_458.ServiceCoverage = data.get('ServiceCoverage') || 0
  form_data_table_458.PostalCodes = data.get('PostalCodes') || ''
  form_data_table_458.Lat = data.get('Lat') || ''
  form_data_table_458.Lng = data.get('Lng') || ''
  form_data_table_458.NeedUpdateInMetalocator = data.get('NeedUpdateInMetalocator') || ''
  form_data_table_458.MainContact = data.get('MainContact') || ''
  form_data_table_458.ZipCodes = data.get('ZipCodes') || ''
  form_data_table_458.ZipCodeCovered = data.get('ZipCodeCovered') || 0
  form_data_table_458.BackupContacts = data.get('BackupContacts') || ''
  form_data_table_458.CoverageNumber = data.get('CoverageNumber') || ''
  form_data_table_458.CoverageUnit = data.get('CoverageUnit') || ''
  form_data_table_458.Completement = data.get('Completement')
  form_data_table_458.ECommerceUrls = data.get('ECommerceUrls') || ''
  form_data_table_458.ECommerceWeDontSellOnline = data.get('ECommerceWeDontSellOnline') || 0
  form_data_table_458.SocialMediaUrls = data.get('SocialMediaUrls') || ''
  form_data_table_458.CompanyLegalNameNonLatin = data.get('CompanyLegalNameNonLatin') || ''

  return form_data_table_458
}

export const CreateLegalExtByModel = (data: DataModel): IForm => {
  const form_data_table_502: IForm = {}

  form_data_table_502.CompanyLegalName = data.get('CompanyLegalNameExt') || ''
  form_data_table_502.CompanyEnglishName = data.get('CompanyEnglishNameExt') || ''
  form_data_table_502.LegalAddr1 = data.get('LegalAddr1Ext') || ''
  form_data_table_502.LegalAddr2 = data.get('LegalAddr2Ext') || ''
  form_data_table_502.LegalAddr3 = data.get('LegalAddr3Ext') || ''
  form_data_table_502.LegalCity = data.get('LegalCityExt') || ''
  form_data_table_502.LegalCountry = data.get('LegalCountryExt') || ''
  form_data_table_502.LegalState = data.get('LegalStateExt') || ''
  form_data_table_502.LegalPostalCode = data.get('LegalPostalCodeExt') || ''
  form_data_table_502.LegalWorkflowStatus = data.get('LegalWorkflowStatusExt') || ''
  form_data_table_502.LegalModifiedValues = data.get('LegalModifiedValuesExt').slice() || ''
  form_data_table_502.LegalApproverComment = data.get('LegalApproverCommentExt') || ''
  form_data_table_502.LegalModified = data.get('LegalModifiedExt') || ''
  form_data_table_502.EntryId = data.get('LegalEntryIdExt') || ''
  form_data_table_502.PartnerID = data.get('PartnerID') || ''
  form_data_table_502.LegalProfilingComment = data.get('LegalProfilingComment') || ''
  form_data_table_502.CompanyLegalNameNonLatin = data.get('CompanyLegalNameNonLatin') || ''
  form_data_table_502.OnboardingRequestId = data.get('OnboardingRequestId') || ''
  form_data_table_502.Market = data.get('Market') || ''
  form_data_table_502.Source = data.get('Source') || ''

  return form_data_table_502
}

type ValidationFn = (v: string) => Promise<string>

interface IValidationPartnerRules {
  [propname: string]: ValidationFn
}

export const ValidationRulesByValue = (isNewPartner: boolean): IValidationPartnerRules => {
  const wRegex = /^[ `~!@#$%^&*()|":<>?.№;_+=/]/
  const emailRegex = /^(\w+[+.-]?)*@\w+([.-]?\w+)*(\.\w{2,9})+$/
  const domainRegex =
    /^(([a-zA-Z]{1})|([a-zA-Z]{1}[a-zA-Z]{1})|([a-zA-Z]{1}[0-9]{1})|([0-9]{1}[a-zA-Z]{1})|([a-zA-Z0-9][a-zA-Z0-9-_]{1,61}[a-zA-Z0-9]))\.([a-zA-Z]{2,6}|[a-zA-Z0-9-]{2,30}\.[a-zA-Z]{2,4})$/
  const URLRegex =
    /(^https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{1,}[^\W]+$|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{1,}[^\W]+$|^https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{1,}[^\W]+$|www\.[a-zA-Z0-9]+\.[^\s]{1,}[^\W])+$/i

  return {
    AddressLine1: async (value: string) => {
      return wRegex.test(value) || value.length < 3 || value.length > 100
        ? `The field AddressLine1 has an incorrect value.  
        Enter at least 3 and must less than 100 characters. 
        Don't use the following:  \`~!@#$%^&*()|":<>?.№;_+=/`
        : ''
    },
    CommunicationName: async (value: string) => {
      return wRegex.test(value) || value.length < 3
        ? 'The field CommunicationName has an incorrect value'
        : ''
    },
    Email: async (value: string) => {
      // strange bug - regular expression is looped if the last character is a dote
      if (value && value[value.length - 1] === '.') {
        return 'The field Email has an incorrect value. Format: [aaa]@[aaa].[aaa]'
      }
      return !emailRegex.test(value)
        ? 'The field Email has an incorrect value. Format: [aaa]@[aaa].[aaa]'
        : ''
    },
    URL: async (value: string) => {
      return !URLRegex.test(value)
        ? `The field URL has an incorrect value. 
        For example https://google.com`
        : ''
    },
    CompanyDomains: async (value: string) => {
      const domainTest = domainRegex.test(value)
      return domainTest || value.length === 0
        ? ''
        : !domainTest
          ? 'The field CompanyDomains has an incorrect value'
          : ''
    },
    City: async (value: string) => {
      //checkCity
      if (isNewPartner) {
        return wRegex.test(value) || value.length < 3 ? 'The field City has an incorrect value' : ''
      }
      return ''
    },
  }
}
